import Turn from "../store/game/types/Turn";

export default function isTurn(
  item: NonNullable<unknown> | null | undefined,
): item is Turn {
  return item !== undefined && item !== null && "actions" in item;
}
